import '../App.css';
import React from 'react';
import Header2 from '../Component/Header';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import { Form } from 'react-bootstrap';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
// import Receipt from '../Images/Receipt.png';
// import Lotto9 from '../Images/Cards/9_Icon.png';
// import MagnumLogo from '../Images/Cards/magnumlogo.png';
// import TotoLogo from '../Images/Cards/toto.png';
// import DamacaiLogo from '../Images/Cards/damacaimobile.png';
// import BT4Logo from '../Images/Cards/bt4DG1mobile.png';
// import Sg4Logo from '../Images/Cards/singaporePool.png';
// import SarawakLogo from '../Images/Cards/sarawak.png';
// import Sabah88Logo from '../Images/Cards/sabah88.png';
// import SansakanLogo from '../Images/Cards/sandakan.png';
import Moment from 'moment-timezone';
import Table from 'react-bootstrap/Table';
import { language } from '../language';
import { Form, Button } from 'react-bootstrap';
import { Platformcolor } from '../static/PlatformColor';
import { findPermutations } from '../utility/Permutation';

const { getnumbertotal82, ZD_getnumbertotal } = require('../Api');
const utilizeScroll = () => {
  
  const elRef = React.createRef();
  const executeScroll = () => elRef.current.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});

  return { executeScroll, elRef };
};

class Page2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      UserID: this.props.userID,
      Username: this.props.username,
      TodayDate: moment(new Date()).format('DD/MM/YYYY (ddd)'),
      Min_Date: Moment(new Date()).toDate(),
      Max_Date: Moment(new Date()).toDate(),
      SelectedDate: Moment(new Date()).toDate(),
      SearchValue: '',
      TextResult: '',
      showShare: true,
      showMAG: true,
      showDMC: true,
      showTOTO: true,
      showSG: true,
      showBT4: true,
      showSTC: true,
      showSBH: true,
      showSWK: true,
      showNumbering: false,
      ChooseStatus: 300, 
      ScrollViewNumb: 6600,
      GameArray: [],
      GameArrayZd: [],
      UseridReport: '', 
      MinimumAmount: '-',
      MaximumAmount: '-',
      MinimumType: 'B,S,SA,SB,SC',
      Loading: false,
      MinimumShowStatus: 'Hide',
      MinimumShowNumber: 'Show',
      // ObjectKeys: ['1','2','3','4','5','6','7','8'],
      ObjectKeys: ['1','2','3','4'],
      WebKeys: ['i82', 'zd'],
      PopScrollBackButton: false,
      LoadingPage: false,
      BetweenType: '-',
      SearchNumber: '',
      searchbox: false,
      searchboxi82: true,
      excludei82dadi: false,
      searchboxzd: false,
      showTotal: [],
    }
    this.SelectedOptionStatus = this.SelectedOptionStatus.bind(this);
    this.Platformcolor = this.Platformcolor.bind(this);
    // this.RunBoolean = this.RunBoolean.bind(this);
    this.elScroll = utilizeScroll();
  }

  async componentDidMount(){
    if (this.props.Role === 'superAdmin' || this.props.Role === 'Admin') {
      this.setState({  MinimumShowNumber: 'Hide'}, () => {
        // console.log('showNumbering', this.state.showNumbering)
      })
    }
    const UserAuthorities = JSON.parse(this.props.UserAuthority)
    if (UserAuthorities.GameBetting.includes('9')) {
      // let ObjectKeys = ['1', '2', '3', '4', '5', '6', '7', '8']
      let ObjectKeys = ['1', '2', '3', '4']
      this.setState({ ObjectKeys: ObjectKeys })
    }
    this.setState({ UserID: (UserAuthorities.isSub === 1) ? UserAuthorities.ActingAs : this.props.userID } , () => {
      // this.CallAPI('B + S')
    })
  }

  async ConfirmSearch(type){
    this.setState({ LoadingPage: true, Loading: false })

    const searchnumberarray = this.state.SearchNumber.split(',')
    let finalsearchnumberarray = []
    if (this.state.searchbox) {
      for (let i = 0; i < searchnumberarray.length; i += 1) {
        const getPermutations = findPermutations(searchnumberarray[i]);
        finalsearchnumberarray = finalsearchnumberarray.concat(getPermutations)
      }
    } else {
      finalsearchnumberarray = searchnumberarray
    }
    finalsearchnumberarray = [...new Set(finalsearchnumberarray)];
    
    const dateToCall = moment(this.state.SelectedDate).format('YYYY-MM-DD')

    const promisesarray = []
    const promisesarrayzd = [];
    promisesarray.push(getnumbertotal82(finalsearchnumberarray.join(','), dateToCall, this.props.token, this.props.username, this.state.excludei82dadi))
    if(this.state.searchboxzd) {
      promisesarrayzd.push(ZD_getnumbertotal(finalsearchnumberarray.join(','), dateToCall, 'xI6HXeQD255UD44b'));
    }
    const result = await Promise.all(promisesarray)
    const zdresult = await Promise.all(promisesarrayzd);
    const numbertoShow = {
      '1': {},
      '2': {},
      '3': {},
      '4': {},
    }
    const numbertoShowzd = {
      '1': {},
      '2': {},
      '3': {},
      '4': {},
    }
    const showTotalObject = {
      'i82': {},
      'zd': {},
    }
    for (let i = 0; i < result.length; i += 1) {
      if (this.state.searchboxi82 && i === 0) {
        const resultarray = result[i]
        for (let j = 0; j < resultarray.length; j += 1) {
          if (!numbertoShow[resultarray[j].platform][resultarray[j].Word]) {
            numbertoShow[resultarray[j].platform][resultarray[j].Word] = {
              B: 0,
              S: 0,
              SA: 0,
            }
          }
          if (!showTotalObject.i82[resultarray[j].Word]) {
            showTotalObject.i82[resultarray[j].Word] = { B: 0, S: 0, SA: 0 }
          }
          numbertoShow[resultarray[j].platform][resultarray[j].Word].B += Number(resultarray[j].B)
          numbertoShow[resultarray[j].platform][resultarray[j].Word].S += Number(resultarray[j].S)
          numbertoShow[resultarray[j].platform][resultarray[j].Word].SA += Number(resultarray[j].A1)
          showTotalObject.i82[resultarray[j].Word].B += resultarray[j].B
          showTotalObject.i82[resultarray[j].Word].S += resultarray[j].S
          showTotalObject.i82[resultarray[j].Word].SA += resultarray[j].A1
        }
      } else if (!this.state.searchboxi82 && i === 0) {
        // ignore
      } else {
        
      }
    }

    if(this.state.searchboxzd) {
      for(let i = 0; i < zdresult.length; i+=1) {
        if (this.state.searchboxzd && i === 0) {
          const resultarray = zdresult[i];
          for (let j = 0; j < resultarray.length; j += 1) {
            if (!numbertoShowzd[resultarray[j].platform][resultarray[j].Word]) {
              numbertoShowzd[resultarray[j].platform][resultarray[j].Word] = {
                B: 0,
                S: 0,
                SA: 0,
              }
            }
            if (!showTotalObject.zd[resultarray[j].Word]) {
              showTotalObject.zd[resultarray[j].Word] = { B: 0, S: 0, SA: 0 }
            }
            numbertoShowzd[resultarray[j].platform][resultarray[j].Word].B += Number(resultarray[j].B)
            numbertoShowzd[resultarray[j].platform][resultarray[j].Word].S += Number(resultarray[j].S)
            numbertoShowzd[resultarray[j].platform][resultarray[j].Word].SA += Number(resultarray[j].A1)
            showTotalObject.zd[resultarray[j].Word].B += resultarray[j].B
            showTotalObject.zd[resultarray[j].Word].S += resultarray[j].S
            showTotalObject.zd[resultarray[j].Word].SA += resultarray[j].A1
          }
        }  else if (!this.state.searchboxi82 && i === 0) {
          // ignore
        } else {
          
        }
      }
    }

    const gamearray = {
      '1': [],
      '2': [],
      '3': [],
      '4': [],
    }
    const gamearrayzd = {
      '1': [],
      '2': [],
      '3': [],
      '4': [],
    }
    for (let i = 1; i <= 4; i += 1) {
      const istring = i.toString()
      const wordarray = Object.keys(numbertoShow[istring])
      for (let j = 0; j < wordarray.length; j += 1) {
        gamearray[istring].push({
          Word: wordarray[j],
          B: numbertoShow[istring][wordarray[j]].B,
          S: numbertoShow[istring][wordarray[j]].S,
          SA: numbertoShow[istring][wordarray[j]].SA,
        })
      }
      gamearray[istring] = gamearray[istring].sort((a, b) => a.B > b.B ? -1 : 1);
      if (wordarray.length > 0) {
        gamearray[istring].GameBoolean = true
      }
    }

    for (let i = 1; i <= 4; i += 1) {
      const istring = i.toString()
      const wordarray = Object.keys(numbertoShowzd[istring])
      for (let j = 0; j < wordarray.length; j += 1) {
        gamearrayzd[istring].push({
          Word: wordarray[j],
          B: numbertoShowzd[istring][wordarray[j]].B,
          S: numbertoShowzd[istring][wordarray[j]].S,
          SA: numbertoShowzd[istring][wordarray[j]].SA,
        })
      }
      gamearrayzd[istring] = gamearrayzd[istring].sort((a, b) => a.B > b.B ? -1 : 1);
      if (wordarray.length > 0) {
        gamearrayzd[istring].GameBoolean = true
      }
    }
    const showTotal = {
      'i82': [],
      'zd': [],
    }
    const platformToDisplay = Object.keys(showTotal);
    for (let i = 0; i < platformToDisplay.length; i += 1) {
      const platform = platformToDisplay[i];
      const wordarray = Object.keys(showTotalObject[platform])

      for (let j = 0; j < wordarray.length; j += 1) {
        showTotal[platform].push({
          Word: wordarray[j],
          B: showTotalObject[platform][wordarray[j]].B,
          S: showTotalObject[platform][wordarray[j]].S,
          SA: showTotalObject[platform][wordarray[j]].SA,
        })
      }
      showTotal[platform] = showTotal[platform].sort((a, b) => a.B > b.B ? -1 : 1);
      if (wordarray.length > 0) {
        showTotal[platform].GameBoolean = true
      }
    }
    this.setState({ GameArray: gamearray, GameArrayZd: gamearrayzd, LoadingPage: false, Loading: true, showTotal })
  }

  toggleResult(platform) {
    let EditBoolean = this.state.GameArray
    EditBoolean[platform] = {...EditBoolean[platform], ...{GameBoolean: !(EditBoolean[platform].GameBoolean)}}
    this.setState({GameArray: JSON.parse(JSON.stringify( EditBoolean))})
  }

  textChange(value, Type){
    if (/^[0-9-]+$/.test(value) || value === '') {

      this.setState({ [Type]: JSON.parse(JSON.stringify(value))}, ()=> {
      })
    } else {
      alert(`${language[this.props.currentLanguage].NumberOnly}`);
    }
  }

  onKeyEnter(event){
    if (event.key === 'Enter') {
      this.CallAPI();
    }
  }

  SelectedOptionStatus(event) {
    this.setState({ChooseStatus: event.target.value}, ()=>{
      this.CallAPI();
    });
  }

  async setSelectedDate(SelectedDate) {
    this.setState({ SelectedDate }, ()=>{
      // this.CallAPI();
    })
  }

  handleScroll(event) {
    var node = event.target;
    if (node.scrollTop > 500) {
      this.setState({
        PopScrollBackButton: true
      });
    } else {
      this.setState({
        PopScrollBackButton: false
      });
    }
  }

  BigToSmall(items) {
    if (this.state.GameArray !== 'No Data') {
      let ReportDetailsFilter = this.state.GameArray
      const BooleanBigorSmall = (items === 'B + S') ? 'BigBandS' : `Big${items}`
      const ArrayNumber = ['1','2','3','4','5','6','7','8']
      let AnswerBoolean = (this.state[`${BooleanBigorSmall}`] === undefined)  ? false : !this.state[`${BooleanBigorSmall}`]
      // console.log('AnswerBoolean',  AnswerBoolean)
      ArrayNumber.forEach((status)=>{
        let ReportDetails = this.state.GameArray[status]
        const FilterUnwantedBoolean = Object.keys(this.state.GameArray[status]).filter((item) =>  item !== 'GameBoolean')
        const Filters = []
        FilterUnwantedBoolean.forEach((item) => Filters.push(this.state.GameArray[status][item]))
        if(items === 'B + S') {
          if(AnswerBoolean === false) {
            Filters.sort((a, b) => (Number(a[items]) > Number(b[items])) ? -1 : 1)
          } else {
            Filters.sort((a, b) => (Number(a[items]) > Number(b[items])) ? 1 : -1)
          }
        } else if (items === 'Number') {
          if(AnswerBoolean === false) {
            Filters.sort((a, b) => (Number(a.Word) > Number(b.Word)) ? -1 : 1)
          } else {
            Filters.sort((a, b) => (Number(a.Word) > Number(b.Word)) ? 1 : -1)
          }
        } else {
          if(AnswerBoolean === false) {
            Filters.sort((a, b) => (Number(a[items]) > Number(b[items])) ? -1 : 1)
          } else {
            Filters.sort((a, b) => (Number(a[items]) > Number(b[items])) ? 1 : -1)
          }
        }
        for (let i = 0; i < Filters.length; i += 1) {
          ReportDetails[i] = Filters[i]
        }
        ReportDetailsFilter[status] = ReportDetails
      })
      this.setState({ GameArray: JSON.parse(JSON.stringify(ReportDetailsFilter)), [`${BooleanBigorSmall}`]: AnswerBoolean })
    }
  }

  // async ExportExcelFile() {
  //   if (this.state.GameArray !== 'No Data') {
  //     exportTotalExcelFight(this.state.GameArray, Moment(this.state.SelectedDate).format('YYYY-MM-DD'), this.state.ChooseStatus, this.state.MinimumType)
  //   } 
  // }

  // async RunBoolean(value) {
  //   this.setState({ MinimumShowNumber: value}, ()=>{
  //     // console.log(value)
  //   })
  // }

  async handleSearchText(e, field) {
    this.setState({ [field]: e.target.value })
  }

  KeyPress(e) {
    if(e.key === 'Enter') {
      this.ConfirmSearch();
    }
  }

  Platformcolor(platform, GDisplay) {
    if (platform === 'Default') return 'lightsteelblue'
    else if (platform === '1' || platform === 'M') return '#faf6b9'
    else if (platform === '2') return '#c8ccfd'
    else if (platform === '3' || platform === 'T') return '#FDBCBC'
    else if (platform === '4' || platform === 'S') return '#CCF2FF'
    return 'lightgray'
  }

  render() {
    return (
      <div onScroll={(e) => this.handleScroll(e)} style={{ width: '100%', height: '100vh', flexDirection: 'column', overflowY: 'auto' }}> 
        <Header2 />
        {this.state.LoadingPage && 
        <>
          <div className='dcc' style={{ fontWeight: 'bold', fontSize: 30, height: '80vh'}}>{language[this.props.currentLanguage].Loading}</div>
        </>}
        {this.state.LoadingPage === false && 
        <>
          <div className="dcc mobileHeader"
            ref={this.elScroll.elRef}
            style={{
              paddingBottom: 0,
              justifyContent: 'space-between',
              marginLeft:  '3.5%',
              flexDirection: 'row',
              width: '95%'
            }}>
            <div style={{ justifyContent: 'center', display: 'flex' }} >
              <div style={{fontSize: "18px", width: 100, fontWeight: 'bold'}}>{language[this.props.currentLanguage].Date} :</div>
              <DatePicker
                onChange = {(Date) => this.setSelectedDate(Date)}
                dateFormat = 'dd-MMM-yyyy'
                placeholder="Date"
                // popperPlacement="top-right"
                selected={this.state.SelectedDate}
                className={"form-control StyleDatePicker"}
                // withPortal
              />
            </div>
          </div>
          <div className='dcc' style={{ flexDirection: 'row', width: 'auto', paddingTop: 0 }}>
            <div style={{ fontWeight: 'bold', width: 'auto', paddingRight: 5 }}>{language[this.props.currentLanguage].nombor}* </div>
            <Form.Control
              value={this.state.SearchNumber}
              style={{
                width: '50%',
                textAlign: 'center',
                fontWeight: 'bold',
                color: '#303030',
              }}
              onKeyPress={(e) => this.KeyPress(e)}
              type="text"
              onChange={(e) => this.handleSearchText(e, 'SearchNumber')}
            />
            <Form.Check
              style={{ fontSize: 18, alignItems: 'center', display: 'flex', marginLeft: 5, fontWeight: 'bold' }}
              inline
              label={'包'}
              type="checkbox"
              checked={this.state.searchbox}
              onChange={(e) => this.setState({ searchbox: !this.state.searchbox})}
            />
            <Form.Check
              style={{ fontSize: 18, alignItems: 'center', display: 'flex', marginLeft: 5, fontWeight: 'bold' }}
              inline
              label={'I82'}
              type="checkbox"
              checked={this.state.searchboxi82}
              onChange={(e) => this.setState({ searchboxi82: !this.state.searchboxi82})}
            />
            
            <Form.Check
              style={{ fontSize: 18, alignItems: 'center', display: 'flex', marginLeft: 5, fontWeight: 'bold' }}
              inline
              label={'102'}
              type="checkbox"
              checked={this.state.searchboxzd}
              onChange={(e) => this.setState({ searchboxzd: !this.state.searchboxzd})}
            />

            <Form.Check
              style={{ fontSize: 18, alignItems: 'center', display: 'flex', marginLeft: 5, fontWeight: 'bold' }}
              inline
              label={'I82 Hide DaDi'}
              type="checkbox"
              checked={this.state.excludei82dadi}
              onChange={(e) => this.setState({ excludei82dadi: !this.state.excludei82dadi})}
            />

            <Button style={{ textAlign: 'center' , color: 'white', width: '30%', fontWeight: 'bold', marginBottom: 5 }}
              className="button2"
              variant="primary"
              onClick={() => this.ConfirmSearch()}>
              {language[this.props.currentLanguage].Search}
            </Button>
          </div>
          <div style={{display: 'flex'}}>
            <div style={{display: 'flex', flexDirection: 'column'}}>
              {(this.state.Loading && (this.state.GameArray !== 'No Data')) && <h4>I82</h4>}
              {(this.state.Loading && this.state.GameArray !== 'No Data') && 
              <Table
                responsive="sm" 
                style={{ backgroundColor: 'white', width: '40%', borderRight: '5px solid black', minHeight: 300, height: '50dvh', overflowY: 'scroll' }}
              >
                <div className="column" style={{ justifyContent: 'center', display: 'flex', paddingLeft: 10 }} >
                  {this.state.ObjectKeys.map((item, index) =>{
                    return (this.state.GameArray[item].GameBoolean) && <div key={index} style={{ paddingBottom: 40, marginRight: 10 }}>
                      <Table>
                        <thead>
                          <tr style={{
                            fontWeight: 'bold',
                            backgroundColor: Platformcolor(item, ''),
                            color: (item === '1') ? 'black' : (item === '7') ? 'black' : (item === '4') ? 'black' : 'white'}} >
                            <th colSpan={4} ><div  style= {{ fontSize: '15px'}}>{(item === '1') ? `${language[this.props.currentLanguage].magnum}` : 
                              (item === '2') ? `${language[this.props.currentLanguage].damacai}` : 
                                (item === '3') ? `${language[this.props.currentLanguage].toto}`: 
                                  (item === '4') ? `${language[this.props.currentLanguage].singapore}`:
                                    (item === '5') ? `${language[this.props.currentLanguage].sarawak}`:
                                      (item === '6') ? `${language[this.props.currentLanguage].sabah}`: 
                                        (item === '7') ? `${language[this.props.currentLanguage].sandakan}`: 
                                          (item === '9') ? `Lotto 9` :
                                            `${language[this.props.currentLanguage].america}` }</div></th>
                          </tr>
                        </thead>
                        <thead>
                          <tr>
                            {(this.state.MinimumShowNumber === 'Show') ? 
                              <th style={{  }}><div>No</div></th>
                              :<></>
                            }
                            <th style={{ padding: 2 }}><div>N</div></th>
                            <>
                              <th style={{ padding: 2}}><div>B</div></th>
                              <th style={{ padding: 2}}><div>S</div></th>
                              <th style={{ padding: 2}}><div>SA</div></th>
                            </>
                            {(this.state.MinimumShowStatus === 'Show')&&<th style={{ padding: 2 }}><div>{language[this.props.currentLanguage].Singular}</div></th>}
                          </tr>
                        </thead>
                        <tbody>
                          { Object.keys(this.state.GameArray[item]).map((NumberItem, ind) =>{
                            return <tr key={ind}>
                              {(this.state.MinimumShowNumber === 'Show') ? 
                                ( Object.keys(this.state.GameArray[item]).length -1 !== ind) &&<th style={{ }}>{ind+1}</th>
                                :<></>
                              }
                              {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') && <th style={{ padding: 2, color: 'black', backgroundColor: '#9AFFF0'}} >{this.state.GameArray[item][NumberItem]['Word'] }</th>}
                              <>
                                {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, backgroundColor: this.Platformcolor(item, ''),borderRight: '1px solid black'}}>{Number(this.state.GameArray[item][NumberItem]['B']).toFixed(2)}</th>}
                                {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, backgroundColor: this.Platformcolor(item, ''),borderRight: '1px solid black'}}>{Number(this.state.GameArray[item][NumberItem]['S']).toFixed(2)}</th>}
                                {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, backgroundColor: this.Platformcolor(item, '')}}>{Number(this.state.GameArray[item][NumberItem]['SA']).toFixed(2)}</th>}
                              </>
                        
                              {(this.state.MinimumShowStatus === 'Show')&& (NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ paddingRight: 5, paddingLeft: 5}}>{Number(this.state.GameArray[item][NumberItem]['TotalOrderCount'])}</th>}
                            </tr>
                          })}
                        </tbody>
                      </Table>
                    </div>
                  })
                  }
                </div>
              </Table>}

              {(this.state.Loading && (this.state.GameArrayZd !== 'No Data')) && <h4>102</h4>}
              {(this.state.Loading && (this.state.GameArrayZd !== 'No Data')) && 
              <Table 
                responsive="sm" 
                style={{ backgroundColor: 'white', width: '100%', borderRight: '5px solid black', minHeight: 300, height: '50dvh', overflowY: 'scroll'}}
              >
                <div className="column" style={{ justifyContent: 'flex-start', display: 'flex', paddingLeft: 10 }} >
                  {this.state.ObjectKeys.map((item, index) =>{
                    return (this.state.GameArrayZd[item].GameBoolean) && <div key={`zd${index}`} style={{ paddingBottom: 40, marginRight: 10, flexGrow: 1 }}>
                      <Table>
                        <thead>
                          <tr style={{
                            fontWeight: 'bold',
                            backgroundColor: Platformcolor(item, ''),
                            color: (item === '1') ? 'black' : (item === '7') ? 'black' : (item === '4') ? 'black' : 'white'}} >
                            <th colSpan={4} ><div  style= {{ fontSize: '15px'}}>{(item === '1') ? `${language[this.props.currentLanguage].magnum}` : 
                              (item === '2') ? `${language[this.props.currentLanguage].damacai}` : 
                                (item === '3') ? `${language[this.props.currentLanguage].toto}`: 
                                  (item === '4') ? `${language[this.props.currentLanguage].singapore}`:
                                    (item === '5') ? `${language[this.props.currentLanguage].sarawak}`:
                                      (item === '6') ? `${language[this.props.currentLanguage].sabah}`: 
                                        (item === '7') ? `${language[this.props.currentLanguage].sandakan}`: 
                                          (item === '9') ? `Lotto 9` :
                                            `${language[this.props.currentLanguage].america}` }</div></th>
                          </tr>
                        </thead>
                        <thead>
                          <tr>
                            {(this.state.MinimumShowNumber === 'Show') ? 
                              <th style={{  }}><div>No</div></th>
                              :<></>
                            }
                            <th style={{ padding: 2 }}><div>N</div></th>
                            <>
                              <th style={{ padding: 2}}><div>B</div></th>
                              <th style={{ padding: 2}}><div>S</div></th>
                              <th style={{ padding: 2}}><div>SA</div></th>
                            </>
                            {(this.state.MinimumShowStatus === 'Show')&&<th style={{ padding: 2 }}><div>{language[this.props.currentLanguage].Singular}</div></th>}
                          </tr>
                        </thead>
                        <tbody>
                          { Object.keys(this.state.GameArrayZd[item]).map((NumberItem, ind) =>{
                            return <tr key={ind}>
                              {(this.state.MinimumShowNumber === 'Show') ? 
                                ( Object.keys(this.state.GameArrayZd[item]).length -1 !== ind) &&<th style={{ }}>{ind+1}</th>
                                :<></>
                              }
                              {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') && <th style={{ padding: 2, color: 'black', backgroundColor: '#9AFFF0'}} >{this.state.GameArrayZd[item][NumberItem]['Word'] }</th>}
                              <>
                                {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, backgroundColor: this.Platformcolor(item, ''),borderRight: '1px solid black'}}>{Number(this.state.GameArrayZd[item][NumberItem]['B']).toFixed(2)}</th>}
                                {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, backgroundColor: this.Platformcolor(item, ''),borderRight: '1px solid black'}}>{Number(this.state.GameArrayZd[item][NumberItem]['S']).toFixed(2)}</th>}
                                {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, backgroundColor: this.Platformcolor(item, '')}}>{Number(this.state.GameArrayZd[item][NumberItem]['SA']).toFixed(2)}</th>}
                              </>
                        
                              {(this.state.MinimumShowStatus === 'Show')&& (NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ paddingRight: 5, paddingLeft: 5}}>{Number(this.state.GameArrayZd[item][NumberItem]['TotalOrderCount'])}</th>}
                            </tr>
                          })}
                        </tbody>
                      </Table>
                    </div>
                  })
                  }
                </div>
              </Table>}
            </div>
            
            {(this.state.Loading && this.state.showTotal !== 'No Data') && <Table responsive="sm" style={{ backgroundColor: 'white', width: '40%' }}>
              <div className="column" style={{ justifyContent: 'center', display: 'flex' }} >
                {  this.state.WebKeys.map((item, index) =>{
                  return (this.state.showTotal[item].GameBoolean) && <div key={index} style={{ paddingBottom: 40, marginRight: 10, paddingLeft: 10 }}>
                    <Table>
                      <thead>
                        <tr style={{
                          fontWeight: 'bold'}} >
                          <th colSpan={(this.state.MinimumShowNumber === 'Show') ? 4 : 3} ><div  style= {{ fontSize: '15px'}}>{item === 'zd' ? '102': item}</div></th>
                        </tr>
                      </thead>
                      <thead>
                        <tr>
                          {(this.state.MinimumShowNumber === 'Show') ? 
                            <th style={{ padding: 2,  }}><div>No</div></th>
                            :<></>
                          }
                          <th style={{ padding: 2,  }}><div>N</div></th>
                          <>
                            <th style={{ padding: 2 }}><div>B</div></th>
                            <th style={{ padding: 2 }}><div>S</div></th>
                            <th style={{ padding: 2 }}><div>SA</div></th>
                          </>
                          {(this.state.MinimumShowStatus === 'Show')&&<th style={{  padding: 2,   }}><div>{language[this.props.currentLanguage].Singular}</div></th>}
                        </tr>
                      </thead>
                      <tbody>
                        { Object.keys(this.state.showTotal[item]).map((NumberItem, ind) =>{
                          return <tr key={ind}>
                            {(this.state.MinimumShowNumber === 'Show') ? 
                              ( Object.keys(this.state.showTotal[item]).length -1 !== ind) &&<th style={{ }}>{ind+1}</th>
                              :<></>
                            }
                            {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') && <th style={{ padding: 2, color: 'black', backgroundColor: '#9AFFF0'}} >{this.state.showTotal[item][NumberItem]['Word'] }</th>}
                            <>
                              {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, borderRight: '1px solid black'}}>{Number(this.state.showTotal[item][NumberItem]['B']).toFixed(2)}</th>}
                              {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, borderRight: '1px solid black'}}>{Number(this.state.showTotal[item][NumberItem]['S']).toFixed(2)}</th>}
                              {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, borderRight: '1px solid black'}}>{Number(this.state.showTotal[item][NumberItem]['SA']).toFixed(2)}</th>}
                            </>
                      
                            {(this.state.MinimumShowStatus === 'Show')&& (NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ paddingRight: 5, paddingLeft: 5}}>{Number(this.state.GameArray[item][NumberItem]['TotalOrderCount'])}</th>}
                          </tr>
                        })}
                      </tbody>
                    </Table>
                  </div>
                })
                }
              </div>
            </Table>}
          </div>
          {(this.state.GameArray.message === 'No Data') && <div className= "dcc">
            <div className="TitleUsername" style={{ width:  '30%'}}>
              {language[this.props.currentLanguage].GameHavenStart}
            </div>
          </div>}
          {(this.state.PopScrollBackButton)&&<div className={"scroll-to-top iconpopup button2"}  
            onClick={this.elScroll.executeScroll}
          >
            <div  className="icon" style={{ fontSize: 25, fontWeight: 'bold' }}>
        ^
            </div>
          </div>}
        </>
        }
      </div >
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    userID: state.userID,
    username: state.username,
    token: state.token,
    Role: state.Role,
    UserAuthority: state.UserAuthority,
    currentLanguage: state.currentLanguage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setDate: (Date) => {
      dispatch({
        type: 'SELECTED_DATE',
        payload: Date,
      });
    },
    setLanguage: (lg) => {
      dispatch({ type: 'SET_LANGUAGE', payload: lg });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Page2);